



























import { Vue, Component } from 'vue-property-decorator';
import Header from './component/header';

@Component ({
  components:{
    Header,
  }
})

export default class Page extends Vue {
  jumpZxgApp() {
    let number:number = 2022;
    let PLAT = {
      MSG: 'msg', // 短信渠道推送
      YYB: 'yyb', // 应用宝渠道
    }
    // if (this.$route.query.plat == 'msg') {
    //   number = 2029;
    // }
    let plat = this.$route.query.plat;
    switch (plat) {
      case PLAT.MSG: 
        number = 2029;
        break;
      case PLAT.YYB: 
        number = 2053;
    }
    location.href = `https://finance.qq.com/products/jumpPage_browser.html?number=${number}&url=https%3A%2F%2Fwzq.tenpay.com%2Factivity%2Fpage%2F190115newyear%2F%3F_from%3Dzxg%26plat%3Dmsg%26stat%3D52p00gf179`;
  }
}
